import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate, useLocation } from "react-router-dom";
import FrontPage from "./components/FrontPage";
import IOSAppPage from "./components/IOSAppPage";
import Dashboard from "./components/Dashboard";
import { FloatingDock } from "./components/FloatingDock";
import { IconHome, IconPizza, IconCalendar, IconApple, IconUser } from '@tabler/icons-react';
import AccountPopup from "./components/AccountPopup";
import ScheduleView from "./components/ScheduleView";
import MenuView from "./components/MenuView";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token') !== null;
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const navItems = [
  { title: "Home", icon: <IconHome size={24} />, href: "/" },
  { title: "Menu", icon: <IconPizza size={24} />, href: "/menu" },
  { title: "Schedule", icon: <IconCalendar size={24} />, href: "/schedule" },
  { title: "IOS", icon: <IconApple size={24} />, href: "/ios-app" },
  { title: "Account", icon: <IconUser size={24} />, href: "/account" },
];

function App() {
  const [showAccountPopup, setShowAccountPopup] = useState(false);
  const [showSchedule, setShowSchedule] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  return (
    <Router>
      <AppContent
        showAccountPopup={showAccountPopup}
        setShowAccountPopup={setShowAccountPopup}
        showSchedule={showSchedule}
        setShowSchedule={setShowSchedule}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
      />
    </Router>
  );
}

function AppContent({
  showAccountPopup,
  setShowAccountPopup,
  showSchedule,
  setShowSchedule,
  showMenu,
  setShowMenu
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleSignIn = () => {
    setShowAccountPopup(false);
    navigate('/?action=signin');
  };

  const handleCreateAccount = () => {
    setShowAccountPopup(false);
    navigate('/?action=create');
  };

  const isDashboard = location.pathname === "/dashboard";

  return (
    <>
      <Routes>
        <Route path="/" element={<FrontPage />} />
        <Route path="/ios-app" element={<IOSAppPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!isDashboard && (
        <FloatingDock
          items={navItems}
          desktopClassName="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50"
          mobileClassName="fixed bottom-4 right-4 z-50"
          setShowAccountPopup={setShowAccountPopup}
          setShowSchedule={setShowSchedule}
          setShowMenu={setShowMenu}
        />
      )}
      {showAccountPopup && (
        <AccountPopup
          onClose={() => setShowAccountPopup(false)}
          onSignIn={handleSignIn}
          onCreateAccount={handleCreateAccount}
        />
      )}
      {showSchedule && (
        <ScheduleView onClose={() => setShowSchedule(false)} />
      )}
      {showMenu && (
        <MenuView onClose={() => setShowMenu(false)} />
      )}
    </>
  );
}

export default App;